/* DON'T EDIT THIS FILE: edit original and run build again */ export const winsecuritiesFullLabel = "WIN SECURITIES S.A";
